import { render, staticRenderFns } from "./Managed-companies-form.vue?vue&type=template&id=398b3328&scoped=true"
import script from "./Managed-companies-form.vue?vue&type=script&lang=js"
export * from "./Managed-companies-form.vue?vue&type=script&lang=js"
import style0 from "./Managed-companies-form.vue?vue&type=style&index=0&id=398b3328&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b3328",
  null
  
)

export default component.exports